import {
    cilFolderOpen,
    cilLockLocked,
    cilSpeedometer,
    cilUser,
    cilSnowflake,
    cibGmail,
    cilCheckCircle,
    cilCircle,
    cilPencil,
    cilBan,
    cilReload,
    cilTrash,
    cilPuzzle,
} from '@coreui/icons'

const icons = {
    cilFolderOpen,
    cilLockLocked,
    cilSpeedometer,
    cilUser,
    cilSnowflake,
    cibGmail,
    cilCheckCircle,
    cilCircle,
    cilPencil,
    cilBan,
    cilReload,
    cilTrash,
    cilPuzzle,
};

export default icons;
